export const CardType = {
  MLB: "mlb",
  NFL: "nfl",
  NHL: "nhl",
  MLBR: "mlb-recharge",
};
